import React, { useEffect } from 'react';
import { useQuery } from '@apollo/react-hooks';
import LoggedLayout from '../../components/Layouts/LoggedLayout';
import { queries } from '../../graphql/graphql';
import { Row, Col, Card, Comment, Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import _s from './index.less';
import { Plans } from '../../components/FloorPlans/List';
import { Link } from 'react-router-dom';

const ViewPage = props => {
  const { match } = props;
  const { params } = match;

  const { loading, data = {}, refetch } = useQuery(queries.ASSISTANT_CHAT, {
    variables: { id: params.id }
  });
  const { assistantChat } = data;

  useEffect(() => {
    refetch();
  }, [data]);

  if (!loading && !assistantChat) return <LoggedLayout>Chat not found.</LoggedLayout>;
  if (loading && !assistantChat) return <LoggedLayout>loading...</LoggedLayout>;

  const { messages, name, email, plans } = assistantChat;

  const getActions = item => {
    const actions = [
      <Link className={_s.action} key={`link-${item._id}`} to={`/plan/${item._id}`}>
        More details
      </Link>
    ];
    return actions;
  };

  return (
    <LoggedLayout>
      <Row justify="center" align="middle" style={{ width: '100%', marginTop: '2em' }}>
        <Col xs={24} sm={24} md={18}>
          <Card style={{ margin: '0.5em' }}>
            <div style={{ marginTop: '2em' }}>
              <p>Name: {name}</p>
              <p>Email: {email}</p>
              <Comment
                className={_s.message}
                key={`message-a`}
                style={{ backgroundColor: '#fafafa' }}
                author={'Assistant'}
                avatar={<Avatar src="/public/images/favicon.ico" alt="Assistant" />}
                content={
                  <div className={_s.titleBird}>
                    <div className={_s.text}>{`Hi ${name}, I'll help you find a house.`}</div>
                    <div className={_s.text}>
                      {`Please write down what you need a house for and what you want. `}
                      <br />
                      {`For example: "I want a small house for one person"`}
                    </div>
                  </div>
                }
              />
              {messages &&
                messages.length > 0 &&
                messages.map((message, key) => (
                  <Comment
                    className={_s.message}
                    key={`message-${key}`}
                    style={{ backgroundColor: key % 2 ? '#fafafa' : 'white' }}
                    author={message.role === 'assistant' ? 'Assistant' : name}
                    avatar={
                      message.role === 'assistant' ? (
                        <Avatar src="/public/images/favicon.ico" alt="Assistant" />
                      ) : (
                        <Avatar icon={<UserOutlined />} />
                      )
                    }
                    content={<p className={_s.text}>{message.text || message.content}</p>}
                  />
                ))}
              <div style={{ marginTop: '2em' }}>
                {plans.length > 0 && (
                  <Plans
                    items={plans}
                    viewMode={0}
                    getActions={getActions}
                    setViewMode={() => null}
                  />
                )}
              </div>
            </div>
          </Card>
        </Col>
      </Row>
    </LoggedLayout>
  );
};

export default ViewPage;
